import { Component } from 'react'
import styled from '@emotion/styled'
import { RowColumn } from 'stylewhere/api'
import { TableColumn, Box } from 'stylewhere/components'

interface Props {
  columns: RowColumn[]
  onReset: (field: string) => void
  onSearch: (field: string, value: string) => void
}

export class TableColumns extends Component<Props> {
  render() {
    const { columns, onReset, onSearch } = this.props
    return (
      <Row row mt={15}>
        {columns.map((col) => {
          return <TableColumn key={col.field} column={col} onReset={onReset} onSearch={onSearch} />
        })}
      </Row>
    )
  }
}

const Row = styled(Box)`
  border-left: 2px solid #ddd;
`
